import type { ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
  /** Auf false setzen, wenn der Aufrufer das Padding selbst über className steuert (z.B. Tabellen mit p-0). */
  padded?: boolean;
}

export function Card({ children, className = "", padded = true }: CardProps) {
  return <div className={`card ${padded ? "p-5" : ""} ${className}`}>{children}</div>;
}

export function CardHeader({ title, subtitle, action }: { title: string; subtitle?: string; action?: ReactNode }) {
  return (
    <div className="flex items-start justify-between mb-4">
      <div>
        <h3 className="text-base font-semibold text-gray-100">{title}</h3>
        {subtitle && <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
